<template>
  <section v-if="content.length" class="message__visualization">
    Visto por:
    <ul class="visualization__participants">
      <li v-for="participant in participants" :key="participant.id">
        <WTooltip
          size="small"
          position="top-right"
          :label="participant.participantTooltip"
        >
          <WAvatar size="xsmall" :url="participant.photoURL" />
        </WTooltip>
      </li>
    </ul>
  </section>
</template>

<script>
import { WAvatar, WTooltip } from '@alice-health/wonderland-vue'

export default {
  components: { WTooltip, WAvatar },
  props: {
    content: {
      type: Array,
      default: () => []
    },
    channelMember: { type: Object, default: undefined },
    channelStaffs: { type: Array, default: () => [] }
  },
  computed: {
    participants() {
      return this.content
        .map(id => {
          const participant =
            this.channelMember?.channelPersonId === id
              ? this.channelMember
              : this.channelStaffs.find(staff => staff.id === id)
          return participant
        })
        .filter(Boolean)
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_non-rendering';
.message__visualization {
  @extend %caption;
  align-items: center;
  color: var(--message-visualization-color);
  display: flex;
  gap: var(--gl-spacing-01);
  padding-bottom: var(--gl-spacing-03);
  padding-top: var(--gl-spacing-04);
  justify-content: flex-end;
  padding-right: var(--gl-spacing-04);

  .visualization__participants {
    display: flex;

    li {
      border: var(--gl-border-width-xs) solid var(--channel-background-color);
      border-radius: var(--gl-border-radius-pill);
      position: relative;
    }

    li + li {
      margin-left: calc(var(--gl-spacing-01) * -1);
    }
  }
}
</style>
